import { ChangeDetectionStrategy, Component } from '@angular/core'

/**
 * GbApplePayIconComponent
 *
 * Recommended padding is already added to the icon, so resize the entire component as needed.
 *
 * More info on the icon here: https://developer.apple.com/apple-pay/marketing/
 */

@Component({
  selector: 'gb-apple-pay-icon',
  templateUrl: './gb-apple-pay-icon.component.html',
  styleUrls: ['./gb-apple-pay-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbApplePayIconComponent {}
